// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"j2H7A":[function(require,module,exports) {
(function($) {
    //- reCAPTCHA V3
    grecaptcha.ready(function() {
        grecaptcha.execute("6LdVWg0lAAAAAOOEf-pPDXccUBco_wZbKNhKelYU", {
            action: "homepage"
        }).then(function(token) {
            document.getElementById("captchaResponse").value = token;
        });
    });
    //- Getting UTMs
    document.addEventListener("DOMContentLoaded", function() {
        // Function to get URL parameters
        function getUTMParameters() {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            var query_string = {};
            for(var i = 0; i < vars.length; i++){
                var pair = vars[i].split("=");
                // If the first element of the pair already exists
                if (typeof query_string[pair[0]] === "undefined") query_string[pair[0]] = decodeURIComponent(pair[1]);
                else if (typeof query_string[pair[0]] === "string") {
                    var arr = [
                        query_string[pair[0]],
                        decodeURIComponent(pair[1])
                    ];
                    query_string[pair[0]] = arr;
                // If it's already an array
                } else query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
            return query_string;
        }
        // Function for saving UTM parameters in sessionStorage
        function saveUTMInSessionStorage() {
            var utmParams = getUTMParameters();
            for(var key in utmParams)sessionStorage.setItem(key, utmParams[key]);
        }
        // Function for inserting sessionStorage values in inputs
        function insertUTMInInputs() {
            for(var i = 0; i < sessionStorage.length; i++){
                var key = sessionStorage.key(i);
                var value = sessionStorage.getItem(key);
                var input = document.getElementById(key);
                if (input) input.value = value;
            }
        }
        // Calls the function to store UTM parameters in the sessionStorage
        saveUTMInSessionStorage();
        // Calls the function to insert sessionStorage values in the inputs
        insertUTMInInputs();
    });
})(jQuery);

},{}]},["j2H7A"], "j2H7A", "parcelRequire94c2")

//# sourceMappingURL=about.379f0940.js.map
